module.exports = __webpack_public_path__ + "img/pick2_yellow.594dc865.png";